(() => {
  'use strict';
  const HANDLES = new Set(['nuit-paisible','digestion','relax','energy','detox','immunite']);
  const quantities = cart => {
    const map = new Map();
    for (const line of cart?.items || []) map.set(String(line.variant_id || line.id), (map.get(String(line.variant_id || line.id)) || 0) + line.quantity);
    return map;
  };
  const eligibleCount = cart => (cart?.items || []).reduce((n, i) => n + (HANDLES.has(i.handle) ? i.quantity : 0), 0);
  function estimate(selected, currency, priorCount = 0) {
    const count = selected.reduce((n, i) => n + i.quantity, 0), totalCount = count + priorCount;
    const subtotal = selected.reduce((n, i) => n + i.quantity * i.variant.price, 0);
    const verified = currency === 'EUR' && selected.every(i => i.variant.price === 1990);
    const unit = totalCount >= 4 ? 1493 : totalCount === 3 ? 1632 : totalCount === 2 ? 1791 : 1990;
    return {count,totalCount,subtotal,total:verified ? count * unit : subtotal,verified,discount:verified ? (totalCount >= 4 ? 25 : totalCount === 3 ? 18 : totalCount === 2 ? 10 : 0) : 0};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {estimate,quantities,eligibleCount};
  if (typeof document === 'undefined') return;
  async function request(url, options = {}) {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {...options,signal:controller.signal,credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json',Accept:'application/json',...options.headers}});
      const data = await response.json();
      if (!response.ok) {const error = new Error(data.description || 'La demande n’a pas pu être confirmée.');error.data=data;throw error;}
      return data;
    } finally {clearTimeout(timer);}
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-quick-order]').forEach(root => {
      if (root.dataset.ready) return;
      let config;try {config=JSON.parse(root.querySelector('[data-order-config]').textContent);}catch{return;}
      root.dataset.ready='true';
      const form=root.querySelector('[data-order-form]'), submit=root.querySelector('[data-order-submit]'), message=root.querySelector('[data-order-error]'), review=root.querySelector('[data-order-review]');
      const rows=[...root.querySelectorAll('[data-order-row]')].map(el=>({el,input:el.querySelector('input'),minus:el.querySelector('[data-order-minus]'),plus:el.querySelector('[data-order-plus]'),variant:config.variants.find(v=>String(v.id)===el.dataset.variantId)})).filter(r=>r.variant);
      const money=cents=>new Intl.NumberFormat(config.locale || 'fr-FR',{style:'currency',currency:config.currency}).format(cents/100);
      const cartUrl=new URL(config.cartUrl,location.origin), base=cartUrl.pathname.replace(/\/$/,'');
      const preview=new URL(location.href).searchParams.get('preview_theme_id');
      if(preview)cartUrl.searchParams.set('preview_theme_id',preview);
      review.href=cartUrl.href;
      let cart=null,busy=false,uncertain=false,reading=false;
      const maxFor=row=>{
        const ceiling=Math.min(row.variant.max ?? Infinity,row.variant.stock ?? Infinity);
        return Math.max(0,ceiling-(quantities(cart).get(String(row.variant.id)) || 0));
      };
      const selected=()=>rows.map(row=>({variant:row.variant,quantity:Number(row.input.value)})).filter(i=>i.quantity>0);
      const readCart=async()=>{
        const data=await request(base+'.js');
        if(!Array.isArray(data.items))throw Error('Panier indisponible.');
        return data;
      };
      const validRow=row=>{
        const n=Number(row.input.value),minimum=row.variant.min || 1,step=row.variant.step || 1;
        return row.input.value!=='' && Number.isSafeInteger(n) && n>=0 && (n===0 || row.variant.available && n>=minimum && (n-minimum)%step===0 && n<=maxFor(row));
      };
      function render(){
        const valid=rows.every(validRow), list=selected(), price=estimate(list,config.currency,eligibleCount(cart));
        rows.forEach(row=>{
          const n=Number(row.input.value),max=maxFor(row),step=row.variant.step || 1,min=row.variant.min || 1;
          row.input.disabled=busy || uncertain || !row.variant.available;
          if(Number.isFinite(max))row.input.max=String(max);else row.input.removeAttribute('max');
          row.input.setCustomValidity(validRow(row) ? '' : 'Choisissez une quantité entière disponible pour cette formule.');
          row.minus.disabled=busy || uncertain || !row.variant.available || !(n>0);
          row.plus.disabled=busy || uncertain || !row.variant.available || (n>0 ? n+step : min)>max;
          row.el.dataset.selected=String(n>0);
          const unit=price.verified && price.count>0 ? price.total/price.count : row.variant.price;
          row.el.querySelector('[data-order-unit]').textContent=money(row.variant.price===1990 && price.verified ? unit : row.variant.price);
        });
        root.querySelector('[data-order-count]').textContent=valid && price.count ? price.count+' flacon'+(price.count>1?'s':'')+' sélectionné'+(price.count>1?'s':'') : 'Choisissez vos quantités';
        root.querySelector('[data-order-total]').textContent=valid && price.count ? money(price.total) : '—';
        root.querySelector('[data-order-savings]').textContent=valid && price.count ? price.discount ? '−'+price.discount+' % · '+money(price.subtotal-price.total)+' économisés sur cette sélection' : price.verified ? '' : 'Montant avant remise éventuelle, confirmé au panier.' : '';
        const prior=eligibleCount(cart),existing=root.querySelector('[data-order-existing]');
        existing.hidden=!prior;
        existing.textContent=prior+' flacon'+(prior>1?'s':'')+' déjà dans votre panier, pris en compte pour la remise.';
        const benefits=root.querySelector('[data-order-benefits]'),shipping=root.querySelector('[data-order-shipping]'),gift=root.querySelector('[data-order-gift]');
        shipping.hidden=!valid || !price.count || price.totalCount<3;
        gift.hidden=!valid || !price.count || price.totalCount<4 || !config.gift?.available;
        const hasGift=(cart?.items || []).some(i=>String(i.product_id)===String(config.gift?.productId));
        gift.textContent=hasGift ? 'Votre surprise de la ferme est déjà dans le panier.' : 'Un cadeau surprise bio de la ferme ajouté à votre panier.';
        benefits.hidden=shipping.hidden && gift.hidden;
        submit.disabled=busy || uncertain || !valid || !price.count;
        if(!busy && !uncertain)submit.textContent=price.count ? 'Ajouter ma sélection au panier' : 'Choisissez vos flacons';
      }
      const showMessage=text=>{message.textContent=text;message.hidden=false;};
      rows.forEach(row=>{
        row.input.addEventListener('input',()=>{if(!busy && !uncertain){message.hidden=true;render();}});
        row.input.addEventListener('change',()=>{if(!validRow(row))row.input.reportValidity();});
        const adjust=direction=>{
          if(busy || uncertain)return;
          const n=Math.max(0,Number(row.input.value)||0),min=row.variant.min||1,step=row.variant.step||1;
          row.input.value=String(direction>0 ? (n ? n+step : min) : (n<=min ? 0 : n-step));
          message.hidden=true;render();
        };
        row.minus.addEventListener('click',()=>adjust(-1));row.plus.addEventListener('click',()=>adjust(1));
      });
      async function refresh(){
        if(reading || busy || uncertain)return;
        reading=true;
        try{cart=await readCart();render();}catch{/* A fresh read is required before any addition. */}
        finally{reading=false;}
      }
      function openFromHash(){
        if(location.hash!=='#composer-commande')return;
        root.open=true;
        document.querySelectorAll('.dz-mobile-menu[open]').forEach(menu=>menu.open=false);
        requestAnimationFrame(()=>root.scrollIntoView({block:'start',behavior:'instant'}));
      }
      document.querySelectorAll('a[href$="#composer-commande"]').forEach(link=>link.addEventListener('click',()=>{
        const url=new URL(link.href,location.origin);
        if(url.pathname===location.pathname){
          root.open=true;
          document.querySelectorAll('.dz-mobile-menu[open]').forEach(menu=>menu.open=false);
          root.querySelector('summary').focus({preventScroll:true});
          refresh();
        }
      }));
      root.addEventListener('toggle',()=>{if(root.open)refresh();});
      window.addEventListener('hashchange',openFromHash);
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(busy || uncertain || !form.reportValidity() || !rows.every(validRow) || !selected().length)return;
        busy=true;message.hidden=true;render();submit.textContent='Vérification de votre panier…';
        let before;
        try{before=await readCart();cart=before;}
        catch{busy=false;render();showMessage('Votre panier n’a pas pu être chargé. Aucun flacon n’a été ajouté. Réessayez.');return;}
        if(!rows.every(validRow)){
          busy=false;render();showMessage('Une quantité dépasse la disponibilité, en tenant compte de votre panier. Ajustez votre sélection.');return;
        }
        const list=selected(),items=list.map(i=>({id:Number(i.variant.id),quantity:i.quantity}));
        const totalCount=eligibleCount(before)+list.reduce((n,i)=>n+i.quantity,0);
        const hasGift=before.items.some(i=>String(i.product_id)===String(config.gift?.productId));
        if(totalCount>=4 && config.gift?.available && !hasGift)items.push({id:Number(config.gift.id),quantity:1,properties:{...config.gift.properties}});
        submit.textContent='Ajout de votre sélection…';
        let failure='';
        try{await request(base+'/add.js',{method:'POST',body:JSON.stringify({items})});}catch(e){failure=e.message;}
        let after;
        try{after=await readCart();}catch{/* Never retry an uncertain mutation. */}
        const previous=quantities(before),current=quantities(after);
        const complete=after && items.every(i=>(current.get(String(i.id))||0)-(previous.get(String(i.id))||0)===i.quantity);
        const giftLines=after?.items.filter(i=>String(i.product_id)===String(config.gift?.productId)) || [];
        const giftOkay=totalCount<4 || !config.gift?.available || giftLines.length>0 && giftLines.every(i=>i.final_line_price===0);
        if(complete && giftOkay){location.assign(cartUrl.href);return;}
        busy=false;uncertain=true;render();
        submit.textContent='Vérifiez votre panier avant un nouvel ajout';
        showMessage(complete && !giftOkay ? 'Vos flacons sont ajoutés, mais la gratuité du cadeau n’a pas pu être confirmée. Vérifiez votre panier.' : 'L’ajout complet n’a pas pu être confirmé. Certains articles peuvent déjà être dans votre panier. Vérifiez-le avant de poursuivre.'+(failure ? ' '+failure : ''));
        review.hidden=false;review.focus();
      });
      form.hidden=false;render();openFromHash();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
